import React from "react";
import { Alert } from "@material-ui/lab";
import MasterBalancesHistoryItem from "./MasterBalancesHistoryItem";
import FragmentSpinner from "../../../elements/spinner/FragmentSpinner";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import { StyledLoadingWrapper } from "../../../elements/spinner/styledSpinner";

const MasterBalancesHistoryList = ({ t, loading, balanceHistory }) => {

  if (loading.main) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (balanceHistory.length === 0) {
    return <Alert severity="warning">{t("history.emptyData")}</Alert>;
  }

  return (
    <>
      <StyledScrollTable>
        <StyledTable
          width="1100"
          size="14"
        >
          <StyledTableHead
            scroll="auto"
            col="5"
          >
            <div>
              {t("history.amount")}
            </div>
            <div>
              {t("history.user")}
            </div>
            <div>
              {t("history.operationType")}
            </div>
            <div>
              {t("history.operationId")}
            </div>
            <div>
              {t("history.createdAt")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {balanceHistory.map((value, key) => (
              <MasterBalancesHistoryItem key={key} value={value} />
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
      {loading.fragment &&
        <StyledLoadingWrapper>
          <FragmentSpinner position="center" />
        </StyledLoadingWrapper>
      }
    </>
  );
};

export default MasterBalancesHistoryList;